import { render, staticRenderFns } from "./AppSubmit.vue?vue&type=template&id=4ae96df2&scoped=true&"
import script from "./AppSubmit.vue?vue&type=script&lang=js&"
export * from "./AppSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae96df2",
  null
  
)

export default component.exports